import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store/index'
import {getToken, setToken} from '@/utils/auth.js'
import Layout from '@/layout/layout.vue';
import LayoutSite from '@/layout/layoutSite.vue';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css'

const qs = require('qs');

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject)
  }
  return originalPush.call(this, location).catch(err => err)
}

export const constantRoutes = [
  {
    path: '/',
    redirect: '/index'
  },
  {
    path: '',
    component: LayoutSite,
    title: '首页',
    meta: {
      menuType: 'C',
    },
    children: [
      // {
      //   name: "ViewHome",
      //   path: '/index',
      //   component: () => import('@/views/home/index.vue'),
      //   meta: {
      //     menuType: 'V',
      //     title: '首页',
      //     cache: false,
      //   },
      // },
      {
        name: 'ViewUserProfile',
        path: '/user/profile',
        title: '个人信息',
        component: () => import('@/views/sys/profile/index.vue'),
        meta: {
          menuType: 'V',
          cache: false,
        },
      },
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [{
      path: '/redirect/:path(.*)',
      component: () => import('@/views/redirect')
    }]
  },

  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },

]

/**
 * 动态路由
 * @type {*[]}
 */
export const dynamicRoutes = [];

console.log("加载路由配置：", constantRoutes);

let router = new VueRouter({
  // mode: 'history',
  routes: constantRoutes
});

/**
 * 白名单路由
 * @type {string[]}
 */
const whiteList = ['/auth-redirect', '/bind', '/register']

/**
 * 页面跳转拦截（导航守卫）
 */
router.beforeEach((to, from, next) => {
  NProgress.start();

  if (process.env.VUE_APP_ENV !== "production") {
    try {
      console.log('页面跳转', 'from=', from, "to=", to);
    } catch (err) {
      console.log(err);
    }
  }

  // 含有三级及多级的parentView的页面向上提一级，才能keepalive
  handleKeepAlive(to);

  // 白名单判断
  if (whiteList.indexOf(to.path) !== -1) {
    next();
    NProgress.done();
  } else {
    let token = getToken();
    if (token) {
      // console.log(to.path + "-------token--->", token)
      // 如果用户session信息为空则获取
      if (!store.getters.username) {
        console.log(to.path + "-------username is empty")
        // 获取用户信息
        store.dispatch('doGetUserSession').then(() => {
          // console.log("-------username--->", store.getters.username)
          // 获取菜单路由
          store.dispatch('doGenMenuRouteList').then(menuRoutes => {
            // 动态添加可访问路由表
            menuRoutes.forEach(item => {
              router.addRoute(item);
            });
            next({...to, replace: true});
            NProgress.done();
          });
        }).catch(err => {
          console.log('异常，跳转到登录页面', err)
          // 抛异常，则返回退出
          store.dispatch('doLogout').then((data) => {
            location.href = data;
          }).catch(err => {
            console.error('异常：', err)
          });
        });
      } else {
        next();
        NProgress.done();
      }
    } else {
      // 解析url参数
      console.log(to.path + "-------token is null- so start get query params-->")
      let queryObj = getQueryParams(window.location.href);
      if (redirectFromUams(queryObj)) {
        let newUrl = getUrlExcludeAuth(queryObj);
        console.log(to.path + "--newUrl-->", newUrl)
        window.location.href = newUrl;
        NProgress.done();
        return;
      }

      console.log('token为空，未登录')
      // ue-router3.0.7之后即3.1.0之后，this.$router.push()返回的是Promise对象，由于导航守卫处理return，没有一个返回值，所以抛异常
      // 在创建router实例对象之前，手动覆盖原型链的push来吞掉报错catch
      store.dispatch('doLogout').then((data) => {
        location.href = data;
      }).catch(err => {
        console.error('异常：', err)
      })
    }
  }
});

/**
 * url获取参数对象返回
 */
function getQueryParams(url) {
  // http://localhost:9920/#/dev/wiki/index?authorization=BearereyJ0eXAiO
  // let parseUrl = {hash: '/dev/wiki/index', query: {authorization: BearereyJ0eXAiO}};
  let parseUrl = {host: '', hash: '', query: {}};
  if (url) {
    let paramIndex = url.indexOf("?");
    if (paramIndex >= 0) {
      let arrParam = url.split("?");
      let host = arrParam[0];
      let query = arrParam[1];
      let hashIndex = host.indexOf("#");
      if (hashIndex >= 0) {
        let arrHash = host.split("#");
        parseUrl.host = arrHash[0];
        parseUrl.hash = arrHash[1];
        parseUrl.query = qs.parse(query);
      } else {
        hashIndex = query.indexOf("#");
        if (hashIndex >= 0) {
          let arrHash = query.split("#");
          parseUrl.host = host;
          parseUrl.query = qs.parse(arrHash[0]);
          parseUrl.hash = arrHash[1];
        }
      }
    }
  }
  return parseUrl;
}

/**
 * 从认证平台跳转过来
 */
function redirectFromUams(queryObj) {
  if (queryObj) {
    let authorization = queryObj.query['authorization'];
    if(Array.isArray(authorization)) {
      authorization = authorization[authorization.length - 1];
    }
    if (authorization) {
      setToken(authorization);
      return true;
    } else {
      console.log('未获取到authorization')
    }
  }
  return false;
}

/**
 * url获取参数对象返回
 */
function getUrlExcludeAuth(queryObj) {
  delete queryObj.query['authorization'];
  let params = qs.stringify(queryObj.query);
  if (params) {
    params = "?" + params;
  }
  let hash = '';
  if (queryObj.hash) {
    hash = "#" + queryObj.hash;
  }
  let redirectUrl = queryObj.host + hash + params;
  return redirectUrl;
}

/**
 * 递归处理多余的 layout : <router-view>，
 * 让需要访问的组件保持在第一层 index : <router-view> 之下
 * @param to
 */
function handleKeepAlive(to) {
  if (to.matched && to.matched.length > 2) {
    for (let i = 0; i < to.matched.length; i++) {
      const element = to.matched[i]
      // 因为import()异步懒加载,第一次获取不到element.components.default.name , 所以不能再beforeEach做,不然第一次访问的界面不缓存第二次才会缓存
      // afterEach就不一样了,这时候可以获取到element.components.default.name了
      if (element.components.default && element.components.default.name === 'ParentView') {
        to.matched.splice(i, 1)
        handleKeepAlive(to)
      }
    }
  }
}

router.afterEach((to, from) => {
  NProgress.done()
});

export default router;
